<template>
  <BottomSheet :open="isOpen" @close="isOpen = false">
    <template #header>
      <div class="flex justify-between items-center w-full">
        <div>
          <div class="flex gap-2 items-center">
            <Icon name="Search" class="h-4 w-4 text-strong" :stroke-width="1.5" />
            <p class="font-inter text-strong text-sm font-medium">Navigation</p>
          </div>
          <h3 class="text-strongest font-semibold text-xl">Select section</h3>
        </div>

        <Button @click="isOpen = false" size="sm" variant="paper-primary">
          <template #icon>
            <Icon name="X" class="h-4 w-4" :stroke-width="2" />
          </template>
        </Button>
      </div>
    </template>

    <div class="p-4 flex flex-col gap-2">
      <!-- Your content here -->
      <div
        v-for="item in navItems"
        @click="
          router.push(item.path);
          isOpen = false;
        "
        class="rounded-[117px] text-strongest px-3 h-9 font-inter flex items-center font-medium cursor-pointer"
        :class="item?.path === activeRoute?.path ? 'bg-tab-bg-selected font-semibold' : ''"
      >
        {{ item.name === "Make An Investment" ? "Make An Investment" : item.name }}
      </div>
      <div>
        <div
          class="rounded-[117px] text-strongest px-3 h-9 font-inter flex items-center font-medium cursor-pointer"
          @click="(contactUsLog(), router.push('/contact-us'), (isOpen = false))"
        >
          Contact Us
        </div>
      </div>
    </div>
  </BottomSheet>
  <div
    class="lg:hidden flex rounded-[117px] justify-between h-7 bg-tab-bg-selected items-center px-3 gap-2 cursor-pointer"
    @click="isOpen = true"
  >
    <p class="font-inter text-sm font-semibold text-strongest">
      {{
        activeRoute?.name === "Make An Investment"
          ? "Make Investment"
          : activeRoute?.name || "Dashboard"
      }}
    </p>
    <Icon name="ChevronDown" class="h-4 w-4 text-cta-tertiary-outline-icon" :stroke-width="1.5" />
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDataStore, useCrudStore } from "@/stores";

import { Icon, BottomSheet, Button } from "@/components";

const route = useRoute();
const router = useRouter();
const isOpen = ref(false);
const dataStore = useDataStore();
const crudStore = useCrudStore();

const activeRoute = computed(() => {
  return navItems.value.find((navItem) => navItem.path === route.path);
});

const navItems = ref([
  { name: "Dashboard", path: "/dashboard" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "Profile", path: "/profile" },
  { name: "Documents", path: "/documents" },
  // { name: "Newsfeed", path: "/newsfeed" },
  { name: "Make An Investment", path: "/make-an-investment" },
]);

async function contactUsLog() {
  let log = {
    step: "Contact Us",
    substep: "",
    status: "Navigated",
    message: "Navigated to Contact Us page - Mobile",
    url: "",
    validation_details: null,
  };

  log = dataStore.setDefaultFields(log, "investoractivity");
  crudStore.insert("investoractivity", [log]);
}
</script>
